import React from 'react';
import {
  Box, Grid, IconButton, Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { observer } from 'mobx-react';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { LevelStore } from '@gamiphy/loyalty-station-desktop/store/level';
import { TierConfigType } from '@gamiphy/bl/level';
import { useTranslation } from '@gamiphy/react-i18n';
import ButtonFactory from '@gamiphy/loyalty-station-desktop/frames/bar/components/ButtonFactory';
import Close from '@mui/icons-material/Close';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useMobile } from '@gamiphy/loyalty-station-desktop/utils/mobile';
import UserPoints from '../progressBar/UserPoints';
import ProgressBar from '../progressBar/ProgressBar';

export type Props = { showLevel: boolean, showProgress: boolean, isBackButton: boolean, handleClick: () => void };

const HeaderProfileCard: React.FC<Props> = observer(({
  showLevel, showProgress, isBackButton, handleClick,
}) => {
  const { user } = UserStore;
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMobile();

  const ArrowIcon = React.useMemo(() => {
    if (theme.direction === 'rtl') {
      return <ArrowForward sx={{ color: 'text.secondary' }} fontSize="large" />;
    }
    return <ArrowBack sx={{ color: 'text.secondary' }} fontSize="large" />;
  }, [theme.direction]);

  return (
    <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap" sx={{ py: 2 }}>
      {!isMobile && (
        <IconButton
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 1,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
            },
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          }}
          onClick={handleClick}
        >
          {isBackButton ? ArrowIcon : <Close sx={{ color: 'text.secondary' }} fontSize="large" />}
        </IconButton>
      )}
      <Grid container spacing={2} alignItems="center" sx={{ position: 'relative' }} size={12}>
        <Grid>
          <Box sx={{
            width: '5.7rem',
            height: '5.7rem',
            borderRadius: '50%',
            border: '1px solid',
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
          }}
          >
            <ButtonFactory />
          </Box>
        </Grid>
        <Grid
          container
          flex={1}
          spacing={1}
        >
          <Grid size={12}>
            <Typography sx={{
              fontSize: '1.4rem',
              fontWeight: 600,
              textTransform: 'capitalize',
              margin: theme.spacing(0, 0, 0.5, 0),
              textAlign: 'left',
              color: theme.palette.text.secondary,
            }}
            >
              {
                user?.firstName ? `${user?.firstName} ${user?.lastName ?? ''}` : `${t('hello', 'hello')}!`
              }
            </Typography>
          </Grid>
          <Grid size={12}>
            {
              showLevel && (
                <Grid size={12} sx={{ width: '100%' }}>
                  <UserPoints />
                </Grid>
              )
            }
          </Grid>

          {
            showProgress && (LevelStore.tierConfig?.type === TierConfigType.exp || LevelStore.tierConfig?.type === TierConfigType.gainedPoints) && (
            <Grid size={12}>
              <ProgressBar />
            </Grid>
            )
          }
        </Grid>
      </Grid>
    </Grid>
  );
});

export default HeaderProfileCard;
